import React from 'react';
import { RouterProvider } from 'react-router';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { router } from './router';
import SessionTimeoutNotification from './components/SessionTimeoutNotification';
import ProgressiveSessionWarnings from './components/ProgressiveSessionWarnings';
import AuthenticationErrorBoundary from './components/AuthenticationErrorBoundary';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthenticationErrorBoundary>
          <AuthProvider>
            <RouterProvider router={router} />
            <SessionTimeoutNotification />
            <ProgressiveSessionWarnings />
          </AuthProvider>
        </AuthenticationErrorBoundary>
      </ThemeProvider>
    </div>
  );
}

export default App;
